import useCourseImportScreen from 'hooks/use-course-import';

import Course from './Course';

const AdminImportCourse = () => {
  const { activeScreen, goto, onPrev, onNext } = useCourseImportScreen();

  return <Course activeScreen={activeScreen} goto={goto} onPrev={onPrev} onNext={onNext} />;
};

export default AdminImportCourse;
